<!--
 * @Description: 按钮
 * @Author: luocheng
 * @Date: 2021-08-23 11:42:01
 * @LastEditors: 冉桂精 156189868@qq.com
 * @LastEditTime: 2023-01-12 10:19:23
-->
<template>
  <el-button :type="statusConfig.type" class="common-button"
    :size="statusConfig.size"
    :plain="statusConfig.plain"
    :round="statusConfig.round"
    :circle="statusConfig.circle"
    :loading="statusConfig.loading"
    :disabled="statusConfig.disabled"
    :icon="statusConfig.icon"
    :autofocus="statusConfig.autofocus"
    :class="{
      'just-icon': !element.propValue
    }"
  >{{ element.propValue || '' }}</el-button>
</template>

<script>
import eventBus from '@/plugins/eventBus';
import { initParams } from '@/utils/tools';
import { dataInterface } from '@/apis/data/index';
import { mapState } from 'vuex';
export default {
  name: 'CommonButton',
  props: {
    // 组件对象
    element: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
		...mapState(['componentData']),
    // 组件配置
    statusConfig() {
      return this.element.statusConfig || {}
    }
  },
	methods: {
		//同步进度计划模型
		onSyncPlanModel(data){
			let obj = {
				"__method_name__": "globalFunctionCall",
				"typeName": "PublicFunc",
				"type": "behavior",
				"funcName": "SpecialPurposeBehavior",
				"payload": {
						"function_name":"TaskToModelComponent"        
				},
				"schedule_id":data.schedule_id
			}
			dataInterface(obj).then((res) => {
				if(res.data.code === 200){
					console.log(res,'同步计划模型成功！')
				}
			}).catch(err => {
				console.log(err, '-----');
			});
		}
	},
	mounted() {
		//监听行为
		eventBus.$on('doComponentBehavior', config => {
			const { component, list = [] } = config;
			let componentName = component.split('-')[0]
			if (!this.element.id.includes(componentName)) return false;
			list.forEach(ele => {
				const { behaviors, params } = ele;
				const { param = {}, canPost } = initParams(params, false, this.componentData, []);
				if (canPost) {
					// 调用行为方法
					behaviors.forEach(funName => {
						try {
							eval(this[funName])(param)
						} catch (err) {
							console.log(err);
						}
					});
				}
			});
		})
	},
	unmounted() {
		eventBus.$off('doComponentBehavior');
	}
}
</script>
<style lang="less">
.el-button{
  &.just-icon{
    border: none;
    span{
      margin-left: 0!important;
    }
  }
}
</style>